export default __webpack_public_path__ + "static/media/icon-insights-menu.705021ec.svg";